import React from 'react';
import PropTypes from 'prop-types';
import styles from './Eyecon.module.scss';
import EyeOnIcon from '../../../assets/svg/EyeOnIcon';
import EyeOffIcon from '../../../assets/svg/EyeOffIcon';

function Eyecon(props) {

  /*
    #NOTE: The onClick is like the following function:
    const toggle = () => {
      props.isOn ? props.onChange(false) : props.onChange(true);
    };
    --  - June 24, 2020
  */

  return (
    <div onClick={() => props.onChange(!props.isOn)} className={styles.container + ' ' + props.className} >
      {
          props.isOn ?
          <EyeOnIcon color="#f37735" /> :
          <EyeOffIcon color="#939393" />
        }
    </div>
  );
}

Eyecon.propTypes = {
  isOn: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Eyecon;